import {Grid, Link, Typography} from "@material-ui/core";
import {ContactMail, ContactPhone, EditSharp, NoteAddSharp} from "@mui/icons-material";

const iconStyles = {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
}
export default function LeadContactInfo({leadInformation}) {

    return (
        <>
            <Grid container>
                <Grid item xs={12} sm={6}  md={3}>
                    <Typography variant={"h5"} component={"div"}>
                        {leadInformation?.leadRequest?.name}
                    </Typography>
                    <Typography color={"textSecondary"}>
                        {leadInformation?.leadAddress?.addressLine1}
                    </Typography>
                    <Typography color={"textSecondary"}>
                        {
                            !!leadInformation?.leadAddress?.addressLine2 &&
                            <>{leadInformation?.leadAddress?.addressLine2},</>
                        }
                        {leadInformation?.leadAddress?.city}, &nbsp;
                        {leadInformation?.leadAddress?.state} &nbsp;
                        {leadInformation?.leadAddress?.zip}
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={6}  md={3}>
                    <Typography>&nbsp;</Typography>
                    <Typography>
                        <div style={iconStyles}>
                            <ContactPhone style={{fill: "darkgray"}}/> &nbsp;
                            <Link
                                href={'tel:' + leadInformation?.leadContact?.cellPhoneNumber}>{leadInformation?.leadContact?.cellPhoneNumber}</Link>
                        </div>
                    </Typography>
                    <Typography>
                        <div style={iconStyles}>
                            <ContactMail style={{fill: "darkgray"}}/> &nbsp;
                            <Link
                                href={'mailto:' + leadInformation?.leadContact?.email}>{leadInformation.leadContact?.email}</Link>
                        </div>
                    </Typography>
                </Grid>
                {/*<Grid item xs={12} sm={6}  md={3}>*/}
                {/*    <Typography>&nbsp;</Typography>*/}
                {/*    <Typography>*/}
                {/*        <div style={iconStyles}>*/}
                {/*            <EditSharp style={{fill: "darkgray"}}/> &nbsp;*/}
                {/*            <Link href={'#'}>{leadInformation?.leadRequest?.publicId}</Link>*/}
                {/*        </div>*/}
                {/*    </Typography>*/}
                {/*</Grid>*/}
                {/*<Grid item xs={12} sm={6}  md={3}>*/}
                {/*    <Typography>&nbsp;</Typography>*/}
                {/*    <Typography>*/}
                {/*        <div style={iconStyles}>*/}
                {/*            <NoteAddSharp style={{fill: "darkgray"}}/> &nbsp;*/}
                {/*            <Link href={'#'}>{leadInformation?.leadRequest?.userRequestStatus}</Link>*/}
                {/*        </div>*/}
                {/*    </Typography>*/}
                {/*</Grid>*/}
            </Grid>
        </>
    );
}
